<template>
  <v-container fill-height fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row wrap>
          <v-spacer></v-spacer>
          <v-flex md4 sm8 xs12>
            <v-card class="elevation-0 bordered-card">
              <v-card-title>
                <div class="title">{{ $t('labels.changePassword') }}</div>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  :label="$t('fields.old_password')"
                  :type="'password'"
                  outline
                  v-if="changeStep == 1"
                  v-model="changeData.old_password"
                ></v-text-field>
                <v-text-field
                  :label="$t('fields.new_password_1')"
                  :type="'password'"
                  outline
                  v-if="changeStep == 2"
                  v-model="changeData.new_password_1"
                ></v-text-field>
                <v-text-field
                  :label="$t('fields.new_password_2')"
                  :type="'password'"
                  outline
                  v-if="changeStep == 2"
                  v-model="changeData.new_password_2"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  @click="setChangeStep(1)"
                  color="primary"
                  v-if="changeStep == 0"
                  >{{ $t('buttons.passwordChange') }}
                </v-btn>
                <v-btn
                  @click="setChangeStep(0)"
                  color="primary"
                  v-if="changeStep == 1"
                  >{{ $t('buttons.cancel') }}
                </v-btn>
                <v-btn
                  @click="setChangeStep(1)"
                  color="primary"
                  v-if="changeStep == 2"
                  >{{ $t('buttons.back') }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="setClick" color="primary" v-if="changeStep == 2"
                  >{{ $t('buttons.passwordSet') }}
                </v-btn>
                <v-btn
                  @click="setChangeStep(2)"
                  color="primary"
                  v-if="changeStep == 1"
                  >{{ $t('buttons.next') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout mt-3 row wrap>
          <v-spacer></v-spacer>
          <v-flex md4 sm8 xs12>
            <v-card class="elevation-0 bordered-card">
              <v-card-title>
                <div class="title">
                  <div>{{ $t('labels.appLanguage') }}</div>
                </div>
              </v-card-title>
              <v-card-text>
                <v-radio-group v-model="selectedLanguage">
                  <v-radio
                    :key="language"
                    :label="$t('languages.' + language)"
                    :value="language"
                    color="primary"
                    v-for="language in $languages"
                  ></v-radio>
                </v-radio-group>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout mt-3 row wrap>
          <v-spacer></v-spacer>
          <v-flex md4 sm8 xs12>
            <v-card class="elevation-0 bordered-card">
              <v-card-title>
                <div class="title">
                  <div>{{ $t('labels.tfa') }}</div>
                </div>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  :label="$t('fields.mobile')"
                  outline
                  v-model="user.mobile"
                ></v-text-field>
                <v-checkbox
                  :label="$t('fields.tfaEnabled')"
                  color="primary"
                  v-model="user.tfa_enabled"
                ></v-checkbox>
              </v-card-text>
              <v-card-actions>
                <v-btn @click="saveTfaClick" color="primary">
                  {{ $t('buttons.save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout mt-3 row wrap>
          <v-spacer></v-spacer>
          <v-flex md4 sm8 xs12>
            <v-card class="elevation-0 bordered-card">
              <v-card-title>
                <div class="title">
                  <div>{{ $t('labels.licenseDetails') }}</div>
                </div>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  :label="$t('fields.clientName')"
                  outline
                  readonly
                  v-model="client.name"
                ></v-text-field>
                <v-text-field
                  :label="$t('fields.address')"
                  outline
                  readonly
                  v-model="client.address"
                ></v-text-field>
                <v-text-field
                  :label="$t('fields.city')"
                  outline
                  readonly
                  v-model="client.city"
                ></v-text-field>
                <v-text-field
                  :label="$t('fields.country')"
                  outline
                  readonly
                  v-model="client.country"
                ></v-text-field>
                <v-text-field
                  :label="$t('fields.oib')"
                  outline
                  readonly
                  v-model="client.oib"
                ></v-text-field>
                <v-text-field
                  :label="$t('fields.contact_person')"
                  outline
                  readonly
                  v-model="client.contact_person"
                ></v-text-field>
                <v-text-field
                  :label="$t('fields.contact_email')"
                  outline
                  readonly
                  v-model="client.contact_email"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout mt-3 row wrap>
          <v-spacer></v-spacer>
          <v-flex md4 sm8 xs12>
            <v-card class="elevation-0 bordered-card">
              <v-card-title>
                <div class="title">
                  <div>{{ $t('labels.tokensTitle') }}</div>
                </div>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  :label="$t('labels.tokensPro')"
                  outline
                  readonly
                  v-model="client.token_pro"
                ></v-text-field>
                <v-text-field
                  :label="$t('labels.tokens2fa')"
                  outline
                  readonly
                  v-model="client.token_2fa"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import handle_session_error from '@/helpers/handle_session_error.js'

export default {
  name: 'Settings',
  data() {
    return {
      changeData: {
        old_password: '',
        new_password_1: '',
        new_password_2: '',
      },
      client: {
        name: '',
        address: '',
        city: '',
        oib: '',
        contact_person: '',
        contact_email: '',
      },
      user: {
        mobile: '',
        tfa_enabled: false,
      },
      changeStep: 0,
      selectedLanguage: '',
    }
  },
  watch: {
    selectedLanguage() {
      var vm = this
      this.$APICall(
        'post',
        'USERS',
        '/set-language',
        { language: this.selectedLanguage },
        function () {
          vm.$i18n.locale = vm.selectedLanguage
          // vm.$vuetify.lang.current = vm.selectedLanguage
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    },
  },
  methods: {
    saveTfaClick() {
      if (
        !this.user.tfa_enabled ||
        (this.user.tfa_enabled && this.user.mobile != '')
      ) {
        let vm = this
        this.$APICall(
          'post',
          'USERS',
          '/set-tfa',
          this.user,
          function () {
            vm.$alert(vm.$t('alerts.savedPopup'))
          },
          true,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      } else {
        this.$alert(this.$t('alerts.mobileMissing'))
      }
    },
    setChangeStep(newStep) {
      this.changeStep = newStep
    },
    setClick() {
      let message = ''
      if (this.changeData.new_password_1 == '') {
        message += this.$t('alerts.newPasswordMissing') + '<br />'
      } else if (this.changeData.new_password_1.length < 8) {
        message += this.$t('alerts.passwordLength') + '<br />'
      } else if (this.changeData.new_password_1.includes(' ')) {
        message += this.$t('alerts.passwordSpaces') + '<br />'
      } else if (
        this.changeData.new_password_1 == this.changeData.old_password
      ) {
        message += this.$t('alerts.newPasswordOldPasswordMatch') + '<br />'
      } else if (
        this.changeData.new_password_1 != this.changeData.new_password_2
      ) {
        message += this.$t('alerts.passwordMatch') + '<br />'
      }
      if (message == '') {
        var vm = this
        this.$APICall(
          'post',
          'USERS',
          '/set-password',
          this.changeData,
          function (data) {
            if (data.success) {
              vm.$alert(vm.$t('alerts.passwordChangeSuccess'))
              vm.$router.push('/events')
            } else {
              vm.$alert(vm.$t('alerts.passwordChangeError'))
            }
          },
          false,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      } else {
        this.$alert(message)
      }
    },
  },
  mounted() {
    this.selectedLanguage = this.$i18n.locale

    this.$APICall(
      'get',
      'USER_PROFILE',
      '',
      {},
      data => {
        this.user = data.data
        this.client = data.data.client
      },
      true,
      error => {
        handle_session_error(error, this.$store, this.$router, this.$prompt)
      }
    )
  },
}
</script>

<style scoped>
.bordered-card {
  border: 2px solid #e8e8e8 !important;
}
</style>
